import { UserStatus, SignupSource, Sections } from 'src/legacy/Components/auth/_constants';

export const determineSignupSourceFromRoute = (pathname: string): string => {
	if (pathname.includes('/checkout')) {
		return SignupSource.CHECKOUT;
	}
	if (pathname.includes('/solucoes')) {
		return SignupSource.LANDING_PAGE;
	}
	if (pathname.includes('/what') || pathname.includes('me/events')) {
		return SignupSource.CREATE_EVENT;
	}
	return SignupSource.WEB;
};
/**
 * Verifica se deve mostrar o modal OTP geral.
 * 
 * Considera o signupSource original do backend + contexto atual (rota).
 * Não altera o signupSource no store, apenas usa para decisão.
 * 
 * Mostra modal quando:
 * - O usuário tem OTP pendente
 * - Não está no checkout
 * - signupSource é 'web' OU 'checkout' (mas não 'create_event' ou 'landing_page')
 */
export const shouldShowGeneralOtpModal = (
	userStatus: string | undefined,
	signupSource: string | undefined,
	isCheckoutRoute: boolean
): boolean => {
	if (isCheckoutRoute) {
		return false;
	}
	if (userStatus !== UserStatus.OTP_PENDING) {
		return false;
	}
	if (
		signupSource === SignupSource.CREATE_EVENT ||
		signupSource === SignupSource.LANDING_PAGE
	) {
		return false;
	}
	return true;
};

/**
 * Verifica se deve limpar o storage ao fechar o modal OTP geral.
 * 
 * O storage é limpo quando:
 * - O usuário tem OTP pendente
 * - O signupSource é 'web' (apenas para contas criadas fora do checkout)
 * 
 * Não limpa para 'checkout' porque o usuário pode ainda estar no checkout em outra aba.
 * Não limpa para 'create_event' ou 'landing_page' para preservar regras de tracking e aquisição.
 */
export const shouldClearStorageOnModalClose = (
	userStatus: string | undefined,
	signupSource: string | undefined,
	isCheckoutRoute: boolean = false
): boolean => {
	return shouldShowGeneralOtpModal(userStatus, signupSource, isCheckoutRoute);
};

export const needsOtpAfterSignup = (
	userStatus: string | undefined,
	signupSource: string | undefined
): boolean => {
	return (
		userStatus === UserStatus.OTP_PENDING &&
		signupSource === SignupSource.WEB
	);
};

/**
 * Verifica se deve limpar o storage ao sair do checkout.
 * O storage é limpo quando:
 * - O usuário tem OTP pendente
 * - O signupSource não é 'create_event' ou 'landing_page' (preserva para não quebrar fluxos)
 */
export const shouldClearStorageOnCheckoutExit = (
	userStatus: string | undefined,
	signupSource: string | undefined
): boolean => {
	return (
		userStatus === UserStatus.OTP_PENDING &&
		signupSource !== SignupSource.CREATE_EVENT &&
		signupSource !== SignupSource.LANDING_PAGE
	);
};

/**
 * Determina qual seção do modal de autenticação deve ser exibida após login,
 * baseado no userStatus e contexto (checkout ou geral).
 * 
 * Centraliza a lógica de decisão para evitar duplicação de código.
 */
export const getAuthSectionAfterLogin = (
	userStatus: string | undefined,
	signupSource: string | undefined,
	isCheckoutRoute: boolean
): string | null => {
	if (userStatus === UserStatus.PENDING) {
		return Sections.COMPLETE_SINGUP;
	}
	if (shouldShowGeneralOtpModal(userStatus, signupSource, isCheckoutRoute)) {
		return Sections.OTP;
	}
	return null;
};
